module.exports = "<app-header-nav>\n</app-header-nav>\n    <router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// D:/FMFB/FMFB Dashboard/src/app/main/main.component.html
// module id = ../../../../../src/app/main/main.component.html
// module chunks = main